import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assests/Images";
import { useMutation, useQuery } from "react-query";
import { executiveData, ordersData } from "../globalApi/Api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { type } from "@testing-library/user-event/dist/type";
import PopupModel from "../popupmodel/PopupModel";
import downloadImage from "../../assests/download.png";
import DatePicker from "react-datepicker";

const ViewOrder = () => {
  const [searchTerm, setSearchTerm] = useState("");
  let role = sessionStorage.getItem("rolebase");

  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [ismodelOpen, setIsmodelOpen] = useState(false);
  const [isIncentiveOpen, setIsIncentiveOpen] = useState(false);

  const [activeTab, setActiveTab] = useState("pending"); // NEW: pending | completed

  const selectedExecutive = watch("executiveName");
  const selectedRoute = watch("lineroute");
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });
  const [executiveRoute, setExecutiveRoute] = useState({
    execvutiveName: "",
    route: "",
    orderDate: "",
  });
  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupType({
      type: "",
      data: "",
    });
  };

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "ordersData",
    ordersData,
    {
      refetchOnWindowFocus: false,
    }
  );

  let details = (data && data?.data) || [];

  // GET API END

  // GET API START FOR EXECUTIVE
  const {
    data: executiveDetails,
    isLoading: executiveLoading,
    refetch: executiveRefetch,
  } = useQuery("executive", executiveData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR EXECUTIVE

  const executives = executiveDetails?.data;

  const filteredDetails =
    details &&
    details
      ?.filter((item) => {
        const lowerSearch = searchTerm?.toLowerCase() || "";

        // Text search: Executive, Customer OR Route Number
        const nameMatch = item?.executiveName
          ?.toLowerCase()
          .startsWith(lowerSearch);

        const customerMatch = String(item?.customerName)
          ?.toLowerCase()
          .startsWith(lowerSearch);

        const routeNoMatch = item?.lineroute
          ?.toLowerCase()
          .startsWith(lowerSearch);

        const textMatch = nameMatch || customerMatch || routeNoMatch;

        // Dropdown filters
        const executiveMatch =
          !selectedExecutive || item?.executiveName === selectedExecutive;

        const routeMatch = !selectedRoute || item?.lineroute === selectedRoute;

        // Date filter
        const itemDateStr = item?.salesDate
          ? moment(item?.salesDate).format("YYYY-MM-DD")
          : null;

        const fromDateStr = fromDate
          ? moment(fromDate).format("YYYY-MM-DD")
          : null;

        const toDateStr = toDate ? moment(toDate).format("YYYY-MM-DD") : null;

        const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
        const toDateMatch = !toDateStr || itemDateStr <= toDateStr;

        const dateMatch = fromDateMatch && toDateMatch;

        return textMatch && executiveMatch && routeMatch && dateMatch;
      })
      ?.sort((a, b) => new Date(b.salesDate) - new Date(a.salesDate));

  const todayStr = moment().format("YYYY-MM-DD");

  // const filteredDetails =
  //   details &&
  //   details
  //     ?.filter((item) => {
  //       // 1️⃣ Skip Delivered or Completed orders
  //       if (
  //         item?.deliveryStatus?.toLowerCase() === "delivered" ||
  //         item?.transactionStatus?.toLowerCase() === "completed"
  //       ) {
  //         return false;
  //       }

  //       // 2️⃣ Format dates
  //       const itemDateStr = item?.salesDate
  //         ? moment(item?.salesDate).format("YYYY-MM-DD")
  //         : null;

  //       const fromDateStr = fromDate
  //         ? moment(fromDate).format("YYYY-MM-DD")
  //         : null;

  //       const toDateStr = toDate ? moment(toDate).format("YYYY-MM-DD") : null;

  //       const fromDateMatch = !fromDateStr || itemDateStr >= fromDateStr;
  //       const toDateMatch = !toDateStr || itemDateStr <= toDateStr;
  //       const dateMatch = fromDateMatch && toDateMatch;

  //       // 3️⃣ Search filter → Include executive, customer, AND now route no
  //       const lowerSearch = searchTerm?.toLowerCase() || "";

  //       const nameMatch = item?.executiveName
  //         ?.toLowerCase()
  //         .includes(lowerSearch);
  //       const customerMatch = String(item?.customerName)
  //         ?.toLowerCase()
  //         .includes(lowerSearch);
  //       const routeNoMatch = item?.lineroute
  //         ?.toLowerCase()
  //         .includes(lowerSearch);

  //       const textMatch = nameMatch || customerMatch || routeNoMatch;

  //       // 4️⃣ Dropdown filters
  //       const executiveMatch =
  //         !selectedExecutive || item?.executiveName === selectedExecutive;
  //       const routeMatch = !selectedRoute || item?.lineroute === selectedRoute;

  //       // 5️⃣ Default filter (show only today's records when no filters applied)
  //       const noFiltersApplied =
  //         !searchTerm &&
  //         !fromDate &&
  //         !toDate &&
  //         !selectedExecutive &&
  //         !selectedRoute;

  //       const todayMatch = noFiltersApplied ? itemDateStr === todayStr : true;

  //       return (
  //         textMatch && executiveMatch && routeMatch && dateMatch && todayMatch
  //       );
  //     })
  //     ?.sort((a, b) => new Date(b.salesDate) - new Date(a.salesDate));

  // DashboadDetails
  let overallOrdes = filteredDetails && filteredDetails?.length;
  const processingCount =
    filteredDetails &&
    filteredDetails?.filter(
      (item) => item?.deliveryStatus?.toLowerCase() === "processing"
    ).length;
  const CanceledCount =
    filteredDetails &&
    filteredDetails?.filter(
      (item) => item?.deliveryStatus?.toLowerCase() === "canceled"
    ).length;
  const returnedCount =
    filteredDetails &&
    filteredDetails?.filter(
      (item) => item?.deliveryStatus?.toLowerCase() === "return"
    ).length;
  const deliveredCount =
    filteredDetails &&
    filteredDetails?.filter(
      (item) => item?.deliveryStatus?.toLowerCase() === "delivered"
    ).length;

  // NEW: Split into pending & completed using existing filteredDetails
  const pendingDetails =
    filteredDetails?.filter(
      (item) =>
        !(
          item?.deliveryStatus?.toLowerCase() === "delivered" ||
          item?.transactionStatus?.toLowerCase() === "completed"
        )
    ) || [];

  const completedDetails =
    filteredDetails?.filter(
      (item) =>
        item?.deliveryStatus?.toLowerCase() === "delivered" ||
        item?.transactionStatus?.toLowerCase() === "completed"
    ) || [];

  // Decide which rows to show in table
  const rowsToShow =
    activeTab === "pending" ? pendingDetails : completedDetails;

  // SELECT ALL IMAGE
  // Keep original allRowIds for popup/download logic (all filteredDetails)
  const allRowIds = filteredDetails?.map((data) => data?.id);

  // New: tableRowIds only for current tab selection
  const tableRowIds = rowsToShow?.map((data) => data?.id) || [];

  const isAllSelected =
    tableRowIds.length > 0 &&
    tableRowIds.every((id) => selectedRows?.includes(id));

  const handleSelectAll = () => {
    if (isAllSelected) {
      // unselect only those in current tab
      setSelectedRows((prev) => prev.filter((id) => !tableRowIds.includes(id)));
    } else {
      // add all ids from current tab, keep others
      setSelectedRows((prev) => [
        ...new Set([...(prev || []), ...tableRowIds]),
      ]);
    }
  };
  // SELECT END

  // DELETE API
  // Delete a user by ID
  const deleteUser = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOST}/orders/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error deleting user with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteUsers = async (ids) => {
    try {
      const results = await Promise.all(
        ids?.map(async (id) => {
          return await deleteUser(id);
        })
      );
      return results; // Return all results after deletion
    } catch (error) {
      console.error("Error deleting multiple users:", error.message);
      throw new Error("Failed to delete multiple users");
    }
  };
  // Mutation to delete users
  const { mutate, isLoading: deleteLoading } = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => {
      setPopupType({
        type: "delete success",
      });
      setSelectedRows([]);
      refetch();
      // ✅ Reload page after deletion
      window.location.reload();
    },
    onError: (error) => {
      console.error("Error deleting rows:", error);
      alert("Error deleting rows");
    },
  });

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.includes(id);
      if (isSelected) {
        return prevSelectedRows?.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  // Handle delete button click
  const handleDelete = () => {
    if (selectedRows?.length === 0) {
      alert("No rows selected");
      return;
    }
    mutate(selectedRows);
  };

  // DELETE API END

  useEffect(() => {
    setExecutiveRoute({
      ...executiveRoute,
      execvutiveName: selectedExecutive,
      route: selectedRoute,
    });
  }, [selectedExecutive, selectedRoute]);

  const routeNames = useMemo(() => {
    return [
      ...new Set(
        (filteredDetails || [])
          .map((item) => item?.lineroute?.trim())
          .filter(Boolean) // Removes undefined, null, empty strings
      ),
    ];
  }, [filteredDetails]);

  return (
    <>
      <div className="view_form_block">
        <div className="view_form_sub_block">
          {/* DASHBOARD */}
          <div className="row my-3 d-flex justify-content-center">
            <div className="col-12 col-sm-6 col-lg-2 dashborad-card-block --first-block">
              <span className="dashboard-heading" style={{ color: "#4B5563" }}>
                OverAll
              </span>
              <span className="dashboard-value">{overallOrdes || 0}</span>
            </div>
            <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block">
              <span className="dashboard-heading" style={{ color: "#92400E" }}>
                Processing
              </span>
              <span className="dashboard-value">{processingCount || 0}</span>
            </div>
            <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block">
              <span className="dashboard-heading" style={{ color: "#7F1D1D" }}>
                Canceled
              </span>
              <span className="dashboard-value">{CanceledCount || 0}</span>
            </div>
            <div className="col-12 col-sm-6 col-lg-2 dashborad-card-block">
              <span className="dashboard-heading" style={{ color: "#1E40AF" }}>
                Return
              </span>
              <span className="dashboard-value">{returnedCount || 0}</span>
            </div>

            <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block --last-block">
              <span className="dashboard-heading" style={{ color: "#065F46" }}>
                Delivered
              </span>
              <span className="dashboard-value">{deliveredCount || 0}</span>
            </div>
          </div>
          {/* ====== ROW 1 (Date + Filters) ====== */}
          <div className="row gx-2 gy-3 align-items-center mt-2">
            <div className="col-12 d-flex flex-wrap justify-content-start align-items-center gap-2">
              {/* From Date */}
              <labe>Filter by date : </labe>
              <div className="col-12 col-sm-6 col-md-3 col-lg-2 p-0">
                <Controller
                  control={control}
                  name="fromDate"
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={field.onChange}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="From Date"
                      maxDate={new Date()}
                      className="filter_date_picker w-100"
                    />
                  )}
                />
              </div>

              {/* To Date */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-2 p-0">
                <Controller
                  control={control}
                  name="toDate"
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={field.onChange}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="To Date"
                      minDate={fromDate}
                      maxDate={new Date()}
                      className="filter_date_picker w-100"
                    />
                  )}
                />
              </div>

              {/* Search */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-2 p-0">
                <input
                  type="search by customer,executive"
                  className="form-control view_table_search"
                  placeholder="Search by customer,executive"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Executive */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-2 p-0">
                <Controller
                  name="executiveName"
                  control={control}
                  render={({ field }) => (
                    <select
                      {...field}
                      className="form-select view-table-status"
                    >
                      <option value="">Executive</option>
                      {executives?.map((data, index) => (
                        <option key={index} value={data.executiveName}>
                          {`${data.executiveName} : ${data.phoneNumber}`}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>

              {/* Route */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-2 p-0">
                <Controller
                  name="lineroute"
                  control={control}
                  render={({ field }) => (
                    <select
                      {...field}
                      className="form-select view-table-status"
                    >
                      <option value="">Route</option>
                      {routeNames?.map((route) => (
                        <option key={route} value={route}>
                          {route}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>
            </div>
          </div>

          {/* ====== ROW 2 (Tabs + Action Buttons) ====== */}
          <div className="row gx-2 gy-3 align-items-center px-2 mt-1">
            <div className="col-12 d-flex flex-wrap  align-items-center justify-content-between">
              {/* ---- Pending / Completed Buttons ---- */}
              <div className="d-flex gap-2 flex-wrap">
                <button
                  type="button"
                  className={`btn ${
                    activeTab === "pending"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => {
                    setActiveTab("pending");
                    setSelectedRows([]);
                  }}
                >
                  Pending ({pendingDetails?.length || 0})
                </button>

                <button
                  type="button"
                  className={`btn ${
                    activeTab === "completed"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => {
                    setActiveTab("completed");
                    setSelectedRows([]);
                  }}
                >
                  Completed ({completedDetails?.length || 0})
                </button>
              </div>

              {/* ---- Right Side Action Buttons ---- */}
              <div className="d-flex flex-wrap gap-2">
                {/* New Order */}
                <div
                  className="download_btn_block_order"
                  onClick={() => navigate("/newOrder")}
                  style={{ width: "auto" }}
                >
                  <button className="download_btn px-4">NEW ORDER</button>
                </div>

                {/* Download */}
                <div
                  className="download_btn_block_order d-flex align-items-center px-3"
                  onClick={() => setIsmodelOpen(true)}
                  style={{ width: "auto" }}
                >
                  {/* <div className="download_image_block px-1">
                    <img
                      src={Images?.downloadIcon}
                      className="image_icon"
                      alt="download"
                    />
                  </div> */}
                  <button className="download_btn">DOWNLOAD</button>
                </div>

                {/* Delete (Shown only in pending & rows selected) */}
                {selectedRows?.length > 0 && activeTab === "pending" && (
                  <div
                    className="download_btn_block_purchase d-flex align-items-center"
                    onClick={() => {
                      setPopupType({ type: "confirm delete" });
                      setIsPopupOpen(true);
                    }}
                  >
                    <div
                      className="download_image_block px-1"
                      style={{ width: "auto" }}
                    >
                      <img
                        src={Images?.deleteIcon}
                        className="image_icon"
                        alt="delete"
                      />
                    </div>
                    <button className="download_btn">DELETE</button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row px-3 my-3">
            <div className="col-lg-12 view_table_section">
              <div className="table-responsive view_table_block">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="view-table-heading">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <input
                            type="checkbox"
                            style={{
                              accentColor: "blue",
                              width: "18px",
                              height: "18px",
                              cursor: "pointer",
                            }}
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                          />
                          SELECT
                        </div>
                      </th>
                      <th className="view-table-heading">ORDER ID</th>
                      <th className="view-table-heading">CUSTOMER</th>
                      <th className="view-table-heading">EXECUTIVE</th>
                      <th className="view-table-heading">ADDRESS</th>
                      <th className="view-table-heading">STATE</th>
                      <th className="view-table-heading">LINE ROUTE</th>
                      <th className="view-table-heading">AMOUNT</th>
                      <th className="view-table-heading">ORDERED DATE</th>
                      <th className="view-table-heading">DELIVERY STATUS</th>
                    </tr>
                  </thead>

                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="10" className="text-center py-3">
                          <h5>L O A D I N G . . .</h5>
                        </td>
                      </tr>
                    ) : rowsToShow?.length > 0 ? (
                      rowsToShow?.map((data, i) => (
                        <tr
                          key={i}
                          onClick={() => {
                            navigate("/invoice", { state: data });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <td
                            className="view-table-data"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="d-flex align-items-center gap-2">
                              {/* ✅ Checkbox */}
                              <input
                                type="checkbox"
                                style={{
                                  accentColor: "blue",
                                  width: "18px",
                                  height: "18px",
                                  cursor: "pointer",
                                }}
                                checked={selectedRows?.includes(data?.id)}
                                onChange={() => handleCheckboxChange(data?.id)}
                              />

                              {/* ✅ Edit Button only for Pending tab */}
                              {activeTab === "pending" && (
                                <button
                                  type="button"
                                  className="btn  btn-outline-primary"
                                  style={{
                                    padding: "2px 10px",
                                    fontSize: "12px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/newOrder", {
                                      state: data,
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                              )}
                            </div>
                          </td>

                          <td className="view-table-data">
                            {data?.orderId || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.customerName || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.executiveName || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.customerAddress || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.state || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.lineroute || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.totalInvoiceAmount || "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.salesDate
                              ? moment(data?.salesDate).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td className="view-table-data">
                            {data?.deliveryStatus || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center py-3">
                          <h6>No Records Found</h6>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedExecutive ? (
        <>
          <button
            type="button"
            className="add_incentive_btn"
            onClick={() => {
              setIsIncentiveOpen(true);
            }}
          >
            Add Incentive
          </button>
        </>
      ) : (
        <></>
      )}

      <PopupModel
        isOpen={isPopupOpen}
        closePopup={handleClosePopup}
        popupType={popupType}
        handleDelete={handleDelete}
        deleteLoading={deleteLoading}
        message="Are you sure you want to delete the order details?"
        setPopupType={setPopupType}
      />

      <PopupModel
        isOpen={ismodelOpen}
        closePopup={() => {
          setIsmodelOpen(false);
        }}
        type="select report"
        filteredDetails={filteredDetails}
        allRowIds={allRowIds}
        executiveNameRoute={executiveRoute}
        selectedRows={selectedRows}
      />

      <PopupModel
        isOpen={isIncentiveOpen}
        closePopup={() => {
          setIsIncentiveOpen(false);
        }}
        type="Incentive"
        incentiveDetails={filteredDetails}
        excutiveName={selectedExecutive}
      />
    </>
  );
};

export default ViewOrder;
